import React, { useState, useRef } from "react";
import formLogo from "../assets/bag.svg";
import ResumeLogo from "../assets/folder.svg";
import { Supabase } from "../utilities/Supabase";

const ContactUs = ({ screenInfo }) => {
  const { isDesktopModeOnMobile, width } = screenInfo;
  const [formData, setFormData] = useState({
    name: "",
    mail_id: "",
    contact: "",
    role: "",
    details: "",
  });
  const [resume, setResume] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [errors, setErrors] = useState({});
  const [statusMessage, setStatusMessage] = useState({ type: "", text: "" });
  const formRef = useRef(null);

  const [fileName, setFileName] = useState("");

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "name":
        if (!value.trim()) error = "Name is required.";
        break;
      case "mail_id":
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
          error = "Enter a valid email address.";
        break;
      case "contact":
        if (!/^[6-9]{1}[0-9]{9}$/.test(value))
          error = "Enter a valid 10-digit contact number.";
        break;
      case "role":
        if (!value) error = "Please select a domain.";
        break;
      case "details":
        if (!value.trim()) error = "Details cannot be empty.";
        break;
      default:
        break;
    }
    return error;
  };

  const validateAllFields = () => {
    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      const error = validateField(key, value);
      if (error) newErrors[key] = error;
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleReset = () => {
    setFormData({ name: "", mail_id: "", contact: "", role: "",details:"" });
    setFileName("");
    setResume(null);
    setErrors({});
  };

  // Handle form submission
  const handleSubmit = async (e) => {
	e.preventDefault();
    setStatusMessage({ type: "", text: "" });

    const isValid = validateAllFields();
    if (!isValid) return;

    setUploading(true);

    
	try {
		
		  const { error: dbError } = await Supabase.from("ContactUs").insert([
			{ ...formData },
		  ]);
      if (dbError) {
        console.error("Supabase insert error:", dbError); 
        setStatusMessage({ type: "error", text: "Error saving form data!" });
      } else {
        setStatusMessage({
          type: "success",
          text: "Form submitted successfully!",
        });
        setTimeout(() => {
          setStatusMessage({ type: "", text: "" });
        }, 3000);

        handleReset();
      }
    } catch (err) {
      setStatusMessage({ type: "error", text: "Something went wrong!" });
      console.log("err", err);
    } finally {
      setUploading(false);
    }
  };
      

  return (
    <div
      className={`${
        isDesktopModeOnMobile && width > 768
          ? "min-h-screen"
          : "lg:min-h-screen  "
      }  w-full  flex  justify-center 2xl:items-center lg:pt-[8rem]  pt-[6rem] sm:py-[8rem]    px-4 sm:px-6 md:px-6 max-sm:pb-0 pb-10 lg:pb-[4.5rem] bg-[linear-gradient(180deg,_rgba(83,64,181,1)_20%,_rgba(27,7,132,1)_100%)]  `}
    >
      <div className="flex flex-col gap-6 sm:gap-8 text-white w-full max-w-screen-md md:max-w-[90vw] lg:max-w-[80vw] xl:max-w-[80vw] 2xl:max-w-[70vw]">
        {/* Heading Section */}
        <div className="flex flex-col gap-4 sm:gap-6 items-center text-center">
          <h1 className="poppins-semibold text-2xl sm:text-3xl md:text-4xl">
            Let’s Talk Business
          </h1>

          <p className="poppins-regular text-sm text-center sm:text-base md:text-lg md:text-left leading-[1.8rem] sm:leading-[1.8rem] md:leading-[2rem]  lg:leading-[2.2rem] tracking-wide opacity-90 px-2 sm:px-4">
            Whether you're looking for tech solutions, collaboration, or expert
            guidance, we're here to help. Reach out to us, and let's explore how
            Optimum Codes can drive your business forward. Let’s build something
            great together!
          </p>
        </div>

        <div className="w-full flex justify-center pb-[5rem]">
          {/* Form */}
          <div className="max-md:w-[90vw] w-[60vw] border-[1px] border-[#FFFFFF47] rounded-[0.5rem] bg-[#FFFFFF14] drop-shadow-xl shadow-2xl">
            <div className="max-md:m-3 m-6 mb-0 flex items-center max-md:p-0 p-2">
              <div className="w-10 h-10 border-[1px] border-[#ffffff5c] rounded-[0.75rem] bg-gradient-to-b from-[#34209A] to-[#523FAE] flex justify-center items-center">
                <img src={formLogo} alt="form-logo" />
              </div>
            </div>
            <div className="mx-6 my-2 px-2">
              <p className="font-bold text-[#DFDFDF]">
                Provide your details to get in touch
              </p>
            </div>
            <form onSubmit={handleSubmit} ref={formRef}>
              <div className="max-md:w-auto max-md:mx-3 max-md:my-2 mx-6 my-4 max-md:h-[30rem] h-[24rem] max-md:space-y-0 space-y-4">
                <div className="w-full max-md:h-[10rem] h-[4rem] flex max-md:block">
                  <div className="w-2/5 max-md:w-full h-full max-md:h-1/2">
                    <div className="h-full flex flex-col justify-center px-2">
                      <div className="relative max-md:h-1/2 h-2/3 border border-[#FFFFFF77] bg-[#FFFFFF22] rounded-lg">
                        <input
                          type="text"
                          name="name"
                          id="floating_outlined_name"
                          onChange={handleChange}
                          className="block px-2.5 pb-4 pt-4 w-full h-full text-sm text-white bg-[#FFFFFF22] rounded-lg  appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                          placeholder=" "
                        />
                        <label
                          htmlFor="floating_outlined_name"
                          className="absolute text-white transform duration-300 peer-placeholder-shown:-translate-y-[30px] peer-placeholder-shown:translate-x-3 peer-placeholder-shown:text-sm max-md:peer-focus:-translate-y-[3.5rem] peer-focus:-translate-y-[3.8rem] max-md:-translate-y-[3.5rem] -translate-y-[3.8rem] peer-focus:-translate-x-0 -translate-x-0 peer-focus:text-xs text-xs peer"
                        >
                          Name
                        </label>
                      </div>
                      {/* 👇 Show validation error if exists */}
                      {errors.name && (
                        <p className="text-red-400 text-xs mt-1  w-full text-center">
                          {errors.name}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="w-3/5 h-full max-md:w-full max-md:h-1/2">
                    <div className="h-full flex flex-col justify-center px-2">
                      <div className="relative max-md:h-1/2 h-2/3 border border-[#FFFFFF77] bg-[#FFFFFF22] rounded-lg">
                        <input
                          type="email"
                          onChange={handleChange}
                          name="mail_id"
                          id="floating_outlined_email"
                          className="block px-2.5 pb-4 pt-4 w-full h-full text-sm text-white bg-[#FFFFFF22] rounded-lg  appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                          placeholder=" "
                        />
                        <label
                          htmlFor="floating_outlined_email"
                          className="absolute text-white transform duration-300 peer-placeholder-shown:-translate-y-[30px] peer-placeholder-shown:translate-x-3 peer-placeholder-shown:text-sm max-md:peer-focus:-translate-y-[3.5rem] peer-focus:-translate-y-[3.8rem] max-md:-translate-y-[3.5rem] -translate-y-[3.8rem] peer-focus:-translate-x-0 -translate-x-0 peer-focus:text-xs text-xs peer"
                        >
                          Mail ID
                        </label>
                      </div>
                      {/* 👇 Show validation error if exists */}
                      {errors.mail_id && (
                        <p className="text-red-400 text-xs mt-1  w-full text-center">
                          {errors.mail_id}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="w-full max-md:h-[5rem] h-[4rem] flex">
                  <div className="w-full h-full flex flex-col justify-center px-2">
                    <div className="relative max-md:h-1/2 h-2/3 border border-[#FFFFFF77] bg-[#FFFFFF22] rounded-lg">
                      <input
                        type="tel"
                        name="contact"
                        onChange={handleChange}
                        id="floating_outlined_number"
                        className="block px-2.5 pb-4 pt-4 w-full h-full text-sm text-white bg-[#FFFFFF22] rounded-lg  appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                        placeholder=" "
                      />
                      <label
                        htmlFor="floating_outlined_number"
                        className="absolute text-white transform duration-300 peer-placeholder-shown:-translate-y-[30px] peer-placeholder-shown:translate-x-3 peer-placeholder-shown:text-sm max-md:peer-focus:-translate-y-[3.5rem] peer-focus:-translate-y-[3.8rem] max-md:-translate-y-[3.5rem] -translate-y-[3.8rem] peer-focus:-translate-x-0 -translate-x-0 peer-focus:text-xs text-xs peer"
                      >
                        Contact No
                      </label>
                    </div>
                    {errors.contact && (
                      <p className="text-red-400 w-full text-center text-xs mt-1">
                        {errors.contact}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full max-md:h-[5rem] h-[4rem]">
                  <div className="w-full h-full flex flex-col justify-center px-2">
                    <div className="w-full relative max-md:h-1/2 h-2/3 border border-[#FFFFFF77] bg-[#FFFFFF22] rounded-lg ">
                      <select
                        id="role"
                        name="role"
                        onChange={handleChange}
                        className="block px-2 w-full h-full text-sm text-white bg-[#FFFFFF22] rounded-lg focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
                      >
                        <option
                          defaultValue
                          className="bg-[#FFFFFF] text-black"
                        >
                          What best describes you ?
                        </option>
                        <option
                          value="A Bussiness Owner"
                          className="bg-[#FFFFFF] text-black"
                        >
                          A Bussiness Owner
                        </option>
                        <option
                          value="Affiliate Marketer"
                          className="bg-[#FFFFFF] text-black"
                        >
                          Affiliate Marketer
                        </option>
                        <option
                          value="I'm a Student"
                          className="bg-[#FFFFFF] text-black"
                        >
                          I'm a Student
                        </option>
                        <option
                          value="Training"
                          className="bg-[#FFFFFF] text-black"
                        >
                          Training
                        </option>
                        <option
                          value="Other"
                          className="bg-[#FFFFFF] text-black"
                        >
                          Other
                        </option>
                        {/* <option value="Ds" className="bg-[#FFFFFF] text-black">Training</option> */}
                      </select>
                      {/* <label htmlFor="domain" className="absolute text-white transform duration-300 peer-placeholder-shown:-translate-y-[30px] peer-placeholder-shown:translate-x-3 peer-placeholder-shown:text-sm peer-focus:-translate-y-[3.5rem] -translate-y-[3.5rem] peer-focus:-translate-x-0 -translate-x-0 peer-focus:text-xs text-xs peer">Domain</label> */}
                    </div>
                    {errors.role && (
                      <p className="text-red-400 w-full text-center text-xs mt-1">
                        {errors.role}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full max-md:h-[5rem] h-[4rem] flex">
                  <div className="w-full h-full flex flex-col justify-center px-2">
                    <div className="relative max-md:h-1/2 h-2/3 border border-[#FFFFFF77] bg-[#FFFFFF22] rounded-lg">
                     <input
                        type="text"
                        name="details"
                        onChange={handleChange}
                        id="floating_looking"
                        className="block px-2.5 pb-4 pt-4 w-full h-full text-sm text-white bg-[#FFFFFF22] rounded-lg  appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                        placeholder=" "
                      />
                      <label
                        htmlFor="floating_looking"
                        className="absolute text-white transform duration-300 peer-placeholder-shown:-translate-y-[30px] peer-placeholder-shown:translate-x-3 peer-placeholder-shown:text-sm max-md:peer-focus:-translate-y-[3.5rem] peer-focus:-translate-y-[3.8rem] max-md:-translate-y-[3.5rem] -translate-y-[3.8rem] peer-focus:-translate-x-0 -translate-x-0 peer-focus:text-xs text-xs peer"
                      >
                        What are u looking for?
                      </label>
                    </div>
                    {/* 👇 Show validation error if exists */}
                    {errors.details && (
                      <p className="text-red-400 text-xs mt-1  w-full text-center">
                        {errors.details}
                      </p>
                    )}
                  </div>
                </div>

                <div className="w-full max-md:h-[5rem] h-[4rem] flex gap-4">
                  {/* Reset Button */}
                  <div className="w-1/2 h-full">
                    <div className="h-full flex flex-col justify-center px-2">
                      <div
                        className="relative max-md:h-1/2 h-2/3 border border-[#FFFFFF77] 
        bg-[#FFFFFF22] hover:bg-[#FFFFFF55] rounded-lg cursor-pointer 
        transition-all duration-300 ease-in-out transform 
        hover:scale-100 active:scale-95 
        shadow-md hover:shadow-white/40 active:shadow-inner"
                      >
                        <input
                          type="reset"
                          value="Reset"
                          onClick={handleReset}
                          id="floating_outlined_name"
                          className="block px-2.5 w-full h-full text-sm text-white 
          bg-transparent rounded-lg appearance-none 
          focus:outline-none focus:ring-0 peer cursor-pointer"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="w-1/2 h-full">
                    <div className="h-full flex flex-col justify-center px-2">
                      <div
                        className="relative max-md:h-1/2 h-2/3 border border-[#FFFFFF77] 
        bg-gradient-to-l from-[#5637B2] to-[#6340CD] 
        rounded-lg cursor-pointer 
        transition-all duration-300 ease-in-out transform 
        hover:scale-100 active:scale-95 
        hover:from-[#7357df] hover:to-[#4a2fa2] 
        shadow-lg hover:shadow-violet-400/40 active:shadow-inner"
                      >
                        <input
                          type="submit"
                          value={uploading ? "Uploading..." : "Submit"}
                          id="floating_outlined_email"
                          className="block px-2.5 w-full h-full text-sm text-white 
          bg-transparent rounded-lg appearance-none 
          focus:outline-none focus:ring-0 peer cursor-pointer"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            {statusMessage.text && (
              <div
                className={`mb-4 max-md:w-auto max-md:mx-5 max-md:my-2 mx-8 text-sm font-medium px-4 py-2 rounded-md text-center ${
                  statusMessage.type === "success"
                    ? "bg-green-500/20 text-green-300 border border-green-500"
                    : "bg-red-500/20 text-red-300 border border-red-500"
                }`}
              >
                {statusMessage.text}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ContactUs;
